// @flow
import { combineReducers } from 'redux';
import scribeConversation from './scribeConversation';
import type { State as conversationState } from './scribeConversation';
import scribeSession from './scribeSession';
import type { State as sessionState } from './scribeSession';
import scribeTranscriptUI from './scribeTranscriptUI';
import type { State as transcriptUIState } from './scribeTranscriptUI';
import firebase from './firebase';
import type { State as firebaseState } from './firebase';
import scribeNotifications from './scribeNotifications';
import type { State as notificationsState } from './scribeNotifications';
import scribeTrainings from './scribeTrainings';
import type { State as trainingsState } from './scribeTrainings';
import scribeDashboard from './scribe-dashboard';
import type { State as dashboardState } from './scribe-dashboard';
import accountReducer from './account';
import type { IState as accountState } from './account';
import savedTranscriptReducer, { State as savedTranscriptState } from './saved-transcript';
import rateConversationReducer, { State as rateConversationState } from './rate-conversation';
import audioRecorderReducer, { State as audioRecorderState } from './audio-recorder';
import ccModeReducer, { State as ccModeState } from './cc-mode';

export interface WholeState {
  scribeConversation: conversationState;
  scribeSession: sessionState;
  scribeTranscriptUI: transcriptUIState;
  firebase: firebaseState;
  scribeNotifications: notificationsState;
  scribeTrainings: trainingsState;
  scribeDashboard: dashboardState;
  account: accountState;
  savedTranscript: savedTranscriptState;
  rateConversation: rateConversationState;
  audioRecorder: audioRecorderState;
  ccMode: ccModeState;
}

// $FlowFixMe
const rootReducer = combineReducers({
  scribeConversation,
  scribeSession,
  scribeTranscriptUI,
  firebase,
  scribeNotifications,
  scribeTrainings,
  scribeDashboard,
  account: accountReducer,
  savedTranscript: savedTranscriptReducer,
  rateConversation: rateConversationReducer,
  audioRecorder: audioRecorderReducer,
  ccMode: ccModeReducer,
});

export default rootReducer;
